import { QueryKey } from "@tanstack/react-query";

export const taskQueryKeys = {
  all: () => ["task"] as QueryKey,
  list: (filters: Readonly<{ [k: string]: any }>) =>
    [...taskQueryKeys.all(), { filters }] as QueryKey,
  details: (taskId?: number) => [...taskQueryKeys.all(), taskId] as QueryKey,
};
